"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retailCustomerAddressText = void 0;
const react_1 = require("react");
const TSalesOrderType_1 = require("../types/TSalesOrderType");
const location_1 = require("../../../../helpers/location");
const retailCustomerAddressText = (locationAddress, orderType) => (0, react_1.useMemo)(() => {
    if (orderType === TSalesOrderType_1.TSalesOrderType.Pickup) {
        return "";
    }
    return (0, location_1.locationAddressText)(locationAddress);
}, [locationAddress, orderType]);
exports.retailCustomerAddressText = retailCustomerAddressText;
//# sourceMappingURL=retailCustomerAddressText.js.map